import { render, staticRenderFns } from "./Step3Confirmation.vue?vue&type=template&id=6d48345c&scoped=true&"
import script from "./Step3Confirmation.vue?vue&type=script&lang=js&"
export * from "./Step3Confirmation.vue?vue&type=script&lang=js&"
import style0 from "./Step3Confirmation.vue?vue&type=style&index=0&id=6d48345c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d48345c",
  null
  
)

export default component.exports